module.exports = __webpack_public_path__ + "img/barre-10.37d64973.png";